module.exports = __webpack_public_path__ + "img/ic_nat_home_wdbg.fa640b21.png";